module.exports = __webpack_public_path__ + "300509399938d6d61ac6c03e6cd70f90.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/latte.png
// module id = 2549
// module chunks = 0